<template>
  <!--  <div style="background-color: #eaeaea">-->
  <div style="background-color: #fff">
    <div style="display: flex;">
      <!-- 顶部工具栏     -->
      <div style="flex: 1;height: 4vh;border-bottom: 1px solid #dce3e8;"></div>
    </div>


    <div style="display: flex">
      <!--  左侧工具栏    -->
      <div id="tool" :style="{ height: '85vh', width: '230px',borderRight: '1px solid #dce3e8' }">
        <div style="height: 30px">工具栏</div>
        <svg id="toolId" width="230px" height="85vh">
        </svg>
      </div>



      <div style="flex: 1">
        <!--    画布    -->
        <div id="canvs" style="height: 60vh;border-bottom: 1px solid #dce3e8;overflow:auto">
          <div style="height: 30px">画布</div>
          <svg id="dagSvg" width="1000%" height="1000%"></svg>
        </div>

        <!--   底部面板     -->
        <div>底部面板</div>
      </div>
    </div>
  </div>


</template>

<script>
import * as d3 from 'd3'
export default {
  name: 'panel',
  components: {
  },
  data() {
    return {
      nodeData: [],
      eageList: [],
      dragFlag: true,
      dragClone: '',
      offsetX: 0,
      offsetY: 0,
      dragWidth: 0,
      dragPanelClone: '',
      toolWidth: 230,
      toolHeight: 0,
      Margin: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 20
      },
      Rectangle: {
        height: 20,
        width: 30
      },
      nodes: [
        { name: '开始节点', icon: '', disabled: false },
        { name: '结束节点', icon: '', disabled: false },
        { name: '普通节点', icon: '', disabled: false },
        { name: '连接线', icon: '', disabled: false }
      ]
    }
  },
  watch: {

  },
  mounted() {
    this.initToolBar()
  },
  methods: {
    /**
     * 画矩形
     *
     * @author        HangerZou
     * @createDate    2021-06-28
     * @version       v1.0
     * @param sel       selection/selections
     * @param id      id
     * @param height  矩形高度
     * @param width   矩形宽度
     * @param color   填充色
     * @param left    水平平移距离
     * @param top     垂直平移距离
     */
    drawRect(sel, id, height, width, color, left, top) {
      sel.append('rect')
        .attr('id', id)
        .attr('height', height)
        .attr('width', width)
        .attr('fill', color)
        .attr('stroke', '#eaeaea')
        .attr('stroke-width', 2)
        .style('cursor', 'pointer')
        .attr('transform', `translate(${left}, ${top})`)
    },
    /**
     * 画圆形
     *
     * @author        HangerZou
     * @createDate    2021-06-28
     * @version       v1.0
     * @param sel       selection/selections
     * @param id      id
     * @param r       半径
     * @param cx      圆心x坐标
     * @param cy      圆心y坐标
     * @param color   填充色
     */
    drawCircle(sel, id, r, cx, cy, color) {
      sel.append('circle')
        .attr('id', id)
        .attr('r', r)
        .attr('cx', cx)
        .attr('cy', cy)
        .attr('fill', color)
        .attr('stroke', '#eaeaea')
        .attr('stroke-width', 2)

    },
    drawLine() {

    },
    /**
     * 写文字
     *
     * @author            HangerZou
     * @createDate        2021-06-28
     * @version           v1.0
     * @param sel         selection/selections
     * @param id          id
     * @param fontFamily  字型
     * @param fontSize    字体大小
     * @param color       填充色
     * @param text        内容
     */
    drawText(sel, id, x, y, fontFamily, fontSize, color, text) {
      sel.append('text')
        .attr('id', id)
        .attr('x', x)
        .attr('y', y)
        .attr('font-family', fontFamily)
        .attr('font-size', fontSize)
        .attr('fill', color)
        .attr('text-anchor', 'start')
        .text(text)
    },

    initToolBar() {
      const toolWidth = this.toolWidth
      const svg = d3.select('#toolId')
      const g = svg.append('g')
      const gStart = svg.append('g').attr('id', 'gStart')

      const panelSvg = d3.select('#dagSvg')
      const dag = panelSvg.append('g')

      //添加流程节点
      this.drawRect(g, 'node', this.Rectangle.height, this.Rectangle.width, '#1BA1E2', this.Margin.left, this.Margin.top)

      //添加流程节点文字
      this.drawText(g, 'nodeText', this.Rectangle.width + (this.Margin.left * 2),
        this.Margin.top + (this.Rectangle.height * 0.75), 'Verdana', '16', '', '流程')



      //添加开始节点
      this.drawCircle(gStart, 'start', this.Rectangle.width / 2, this.Margin.left + this.Rectangle.width / 2,
        this.Margin.top * 2 + this.Rectangle.height + this.Rectangle.width / 2, 'green')

      this.drawText(gStart, 'startText1', this.Margin.left + this.Rectangle.width / 4,
        this.Margin.top * 2 + this.Rectangle.height + this.Rectangle.width * 0.65, 'Verdana', '16',
        '#fff', '始')

      this.drawText(g, 'startText2', this.Margin.left * 2 + this.Rectangle.width,
        this.Margin.top * 2 + this.Rectangle.height + this.Rectangle.width * 0.65, 'Verdana', '16',
        '', '开始')


      //添加结束节点
      this.drawCircle(g, 'end', this.Rectangle.width / 2, this.Margin.left + this.Rectangle.width / 2,
        this.Margin.top * 3 + this.Rectangle.height + this.Rectangle.width * 1.5, '#D80073')

      this.drawText(g, 'endText1', this.Margin.left + this.Rectangle.width / 4,
        this.Margin.top * 3 + this.Rectangle.height + this.Rectangle.width * 1.65, 'Verdana', '16',
        '#fff', '止')

      this.drawText(g, 'endText2', this.Margin.left * 2 + this.Rectangle.width,
        this.Margin.top * 3 + this.Rectangle.height + this.Rectangle.width * 1.65, 'Verdana', '16',
        '', '结束')
      //添加线段

      //添加defs标签
      const defs = svg.append('defs')
      //添加marker标签及其属性
      const arrowMarker = defs.append('marker')
        .attr('id', 'arrow')
        .attr('markerUnits', 'strokeWidth')
        .attr('markerWidth', 8)
        .attr('markerHeight', 8)
        .attr('viewBox', '0 0 8')
        .attr('refX', 4)
        .attr('refY', 4)
        .attr('orient', 'auto')
      //绘制直线箭头
      const arrow_path = 'M2,2 L6,4 L2,6 L4,4 L2,2'
      arrowMarker.append('path')
        .attr('d', arrow_path)
        .attr('fill', '#000')
      const data = [[this.Margin.left, this.Margin.top * 4 + this.Rectangle.height + this.Rectangle.width * 2.5],
        [this.Margin.left + this.Rectangle.width, this.Margin.top * 4 + this.Rectangle.height + this.Rectangle.width * 2.5]]
      const lineGenerator = d3.line()
      const pathString = lineGenerator(data)
      // d3.select('path').attr('d', pathString)

      g.append('path')
        .attr('d', pathString)
        .attr('stroke', 'steelblue')
        .attr('stroke-width', 3)
        .attr('fill', 'none')
        .attr('marker-start', 'url(#circle)')
        .attr('marker-end', 'url(#arrow)')

      this.drawText(g, 'lineText2', this.Margin.left * 2 + this.Rectangle.width,
        this.Margin.top * 4 + this.Rectangle.height + this.Rectangle.width * 2.75, 'Verdana', '16',
        '', '连线')

      // 返回唯一标识
      function getUUID() {
        return Math.random().toString(36).substr(3, 10)
      }
      /**
       * 获取G元素的XY坐标位置
       *
       * @author      ZhengWei(HY)
       * @createDate  2018-10-23
       * @version     v1.0
       */
      function getGXY(i_G) {
        var v_Ret = i_G.attr('transform').replace('translate(', '').replace(')', '')

        if (v_Ret.indexOf(',') >= 0) {
          return v_Ret.split(',')
        } else if (v_Ret.indexOf(' ') >= 0) {
          /* IE浏览器有用空格分割位置XY的情况 */
          return v_Ret.split(' ')
        } else {
          return (v_Ret + ',0').split(',')
        }
      }
      const dragCircle = d3.drag()
        .on('start', toCirlcleDraged) // 拖动开始，触发一次
        .on('drag', circledraged) // 拖动中，触发多次
        .on('end', dragedEnd) // 拖动结束，触发一次

      const drag = d3.drag()
        .on('start', toDraged) // 拖动开始，触发一次
        .on('drag', draged) // 拖动中，触发多次
        .on('end', dragedEnd) // 拖动结束，触发一次

      //圆形拖拽开始
      function toCirlcleDraged() {
        this.dragClone = d3.select(this)
          .clone(true)
        this.offsetX = this.dragClone.attr('cx')
        this.offsetY = this.dragClone.attr('cy')
        this.dragWidth = this.dragClone.attr('r') * 2
        // this.offsetX = getGXY(this.dragClone)[0]
        // this.offsetY = getGXY(this.dragClone)[1]
        dag.append('circle')
          .attr('id', 'temp01')
          .attr('r', this.dragClone.attr('r') * 2)
          .attr('fill', 'none')
      }
      function circledraged() {
        const leftX = toolWidth - this.dragWidth
        const rightX = toolWidth

        if (d3.event.x < leftX) {
          dag.select('#temp01')
            .attr('fill', 'none')
            .attr('stroke', '#000')
            .attr('stroke-width', 0)
        }
        if (d3.event.x > leftX && d3.event.x < rightX) {
          const tempWidth = dag.select('#temp01').attr('width')
          const cloneWidth = this.dragClone.attr('width')
          dag.select('#temp01')
            .attr('cx', ((d3.event.x - 200) / cloneWidth * tempWidth) - tempWidth)
            .attr('cy', d3.event.y)
            .attr('fill', this.dragClone.attr('fill'))
            .attr('stroke', '#000')
            .attr('stroke-width', 2)
        }
        if (d3.event.x > rightX) {
          dag.select('#temp01')
            .attr('cx', d3.event.x - 230)
            .attr('cy', d3.event.y)
            .attr('fill', this.dragClone.attr('fill'))
        }
        this.dragClone
          .attr('cx', d3.event.x - 20)
          .attr('cy', d3.event.y - 20)
        console.log('cx', d3.event.x)
        console.log('cy', d3.event.y)
      }


      //拖拽开始
      function toDraged() {
        this.dragClone = d3.select(this)
          .clone(true)
        // this.offsetX = this.dragClone.attr('x')
        this.offsetX = getGXY(this.dragClone)[0]
        this.offsetY = getGXY(this.dragClone)[1]
        this.dragWidth = this.dragClone.attr('width')
        dag.append('rect')
          .attr('id', 'temp01')
          .attr('height', this.dragClone.attr('height') * 2)
          .attr('width', this.dragClone.attr('width') * 2)
          .attr('fill', 'none')
      }
      //拖拽进行中
      function draged() {
        const leftX = toolWidth - this.dragWidth
        const rightX = toolWidth

        if (d3.event.x < leftX) {
          dag.select('#temp01')
            .attr('fill', 'none')
            .attr('stroke', '#000')
            .attr('stroke-width', 0)
        }
        if (d3.event.x > leftX && d3.event.x < rightX) {
          const tempWidth = dag.select('#temp01').attr('width')
          const cloneWidth = this.dragClone.attr('width')
          dag.select('#temp01')
            .attr('x', ((d3.event.x - 200) / cloneWidth * tempWidth) - tempWidth)
            .attr('y', d3.event.y)
            .attr('fill', this.dragClone.attr('fill'))
            .attr('stroke', '#000')
            .attr('stroke-width', 2)
        }
        if (d3.event.x > rightX) {
          dag.select('#temp01')
            .attr('x', d3.event.x - 230)
            .attr('y', d3.event.y)
            .attr('fill', this.dragClone.attr('fill'))
        }
        this.dragClone
          .attr('x', d3.event.x - 20)
          .attr('y', d3.event.y - 20)
        console.log('cx', d3.event.x)
        console.log('cy', d3.event.y)
      }

      function dragedEnd() {
        // if (d3.event.x < 180) {
        // }
        if (d3.event.x < toolWidth) {
          dag.select('#temp01').remove()
          this.dragClone.remove()
          alert('请将节点完全拖拽入画布')
        }
        if (d3.event.x > 230) {
          dag.select('#temp01').attr('id', getUUID)
          this.dragClone.remove()
          console.log('d3.event.x', d3.event.x)
        }
      }

      g.selectAll('rect')
        .call(drag)

      g.selectAll('#gStart')
        .call(dragCircle)
    }
  }
}
</script>
<style>
  rect:hover{

    fill : red;}
</style>
